<script setup lang="ts">
import type { SidebarProps } from '@/components/ui/sidebar'
import { Sidebar, SidebarContent, SidebarRail } from '@/components/ui/sidebar'
import IconStrip from '@/layouts/frame/IconStrip.vue'
import SectionSidebar from '@/layouts/frame/SectionSidebar.vue'

/**
 * The app frame's left side: the icon strip, then the section sidebar for the
 * area you are in. Which areas, entities and pages show is decided by the area
 * table and its gates in src/navigation, not here. The old "Search" page grant
 * no longer gates anything.
 */
const props = withDefaults(defineProps<SidebarProps>(), {
  collapsible: 'icon',
})
</script>

<template>
  <!--
    Two columns inside one shadcn sidebar: the icon strip, then the section
    column. Collapsing the sidebar to its icon width hides the section column
    and leaves the strip, which is the "hide sidebar" behaviour.
  -->
  <Sidebar v-bind="props" collapsible="icon" class="overflow-hidden *:data-[sidebar=sidebar]:flex-row">
    <IconStrip class="border-r border-sidebar-border" />
    <SidebarContent class="min-w-0 flex-1 group-data-[collapsible=icon]:hidden">
      <SectionSidebar />
    </SidebarContent>
    <SidebarRail />
  </Sidebar>
</template>
